import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import PostRquirementView from "../screens/PostSearch/post";
import ProfileView from "../screens/Profile/ProfileView";
import ViewCandidateDetails from "../screens/SearchCandidate/ViewCandidateDetails";
import ViewPublicResume from "../screens/SearchCandidate/ViewPublicResume";
import PostRequestSubmit from "../screens/SearchCandidate/PostRequestSubmit";
import ViewInternalResumeDetails from "../screens/PostSearch/ViewInternalResumeDetails";
import MassMailing from "../screens/MassMailing";
import MassMailingPortal from "../screens/MassMailing/MassMailingPortal";
import AddConsultant from "../screens/Candidates/AddCandidate/AddConsultant";
import PostSearchResult from "../screens/SearchCandidate/PostSearchResult";
import MassMailingPortalNew from "../screens/MassMailing/MassMailingPortalNew";
import MassMailingSalesRecruiter from "../screens/MassMailing/MassMailingSalesRecruiter";
import InternalTracker from "../screens/InternalTracker/Candidate/index";
import RequirementsTracker from "../screens/InternalTracker/Requirements/RequirementsTracker";
import InternalTrackerView from "../screens/InternalTracker/Candidate/InternalTrackerView";
import InternalView from "../screens/InternalTracker/Requirements/InternalView";
import InternalAdd from "../screens/InternalTracker/Requirements/InternalAdd";
import InternalTrackerCandidate from "../screens/InternalTracker/Candidate/InternalTrackerCandidate";
import InternalRequirement from "../screens/InternalTracker/Requirements/InternalRequirement";
import InternalTrackerSubmit from "../screens/InternalTracker/Candidate/InternalTrackerSubmit";
import InternalSubmit from "../screens/InternalTracker/Requirements/InternalSubmit";
import PostSearch from "../screens/PostSearch";
import JobPostListView from "../screens/PostSearch/JobPostListView";
import Profile from "../screens/Profile";
import PostJobRequirement from "../screens/PostSearch/PostJobRequirement";
import SearchCandidate from "../screens/PostSearch/SearchCandidate";
import CandidateViewResume from "../screens/PostSearch/CandidateViewResume";
import InternalTrackerSubmissions from "../screens/InternalTracker/Requirements/InternalTrackerSubmissions";
import InternalTrackerEmployee from "../screens/InternalTracker/Requirements/InternalTrackerEmployee";
import DashboardCredit from "../screens/Dashboard/DashboardCredit";
import DashboardTransfer from "../screens/Dashboard/DashboardTransfer";
import ProfileSave from "../screens/Profile/ProfileSave";
import InternalTrackerAddReview from "../screens/InternalTracker/Candidate/InternalTrackerAddReview";
import BenchView from "../screens/PostSearch/BenchView";
import MoreView from "../screens/InternalTracker/Candidate/MoreView";
import MoreViewDetails from "../screens/InternalTracker/Candidate/MoreViewDetails";
import MoreViewInternalDetails from "../screens/InternalTracker/Candidate/MoreViewInternalDetails";
import SendJob from "../screens/InternalTracker/Candidate/SendJob";
import SendJobInternal from "../screens/InternalTracker/Candidate/SendJobInternal";
import HelpDesk from "../screens/HelpDesk";
import Invite from "../screens/Invite";
import Requirement from "../screens/Requirement";
import RequirementView from "../screens/Requirement/RequirementView";
import RequirementApplyView from "../screens/Requirement/RequirementApplyView";
import RequirementAskView from "../screens/Requirement/RequirementAskView";
import ApplyNow from "../screens/Requirement/ApplayNow";
import ActiveJobs from "../screens/HomeNew/ActiveJobs";
import SignupNew from "../screens/Auth/Signupnew";
import LoginNew from "../screens/Auth/LoginNew";
import BenchSalesSignup from "../screens/Auth/BenchSalesSignup";
import RequirementPost from "../screens/Requirement/RequirementPost";
import InternalTrackerExperience from "../screens/InternalTracker/Candidate/InternalTrackerExperience";
import HomeNew from "../screens/HomeNew/index";
import ContactUsNew from "../screens/HomeNew/ContactUs";
import AboutUsNew from "../screens/HomeNew/AboutUs";
import OurPlatformNew from "../screens/HomeNew/OurPlatform";
import SecurityNew from "../screens/HomeNew/Security";
import FeedbackMore from "../screens/HomeNew/FeedbackMore";
import FeedbackNext from "../screens/HomeNew/FeedbackNext";
// benchsales routes

import AddPersonal from "../screens2/Candidates/AddCandidate/AddPersonal";
import AddCandidatePublic from "../screens2/Candidates/AddCandidate/AddCandidatePublic";
import AddCandidateResume from "../screens2/Candidates/AddCandidate/AddCandidateResume";
import CandidateListing from "../screens2/Candidates/CandidateListing/CandidateListing";
import Requirementss from "../screens2/Requirement";
import MoreViews from "../screens2/Requirement/MoreView";
import MoreViewApply from "../screens2/Requirement/MoreViewApply";
import MoreViewAsk from "../screens2/Requirement/MoreViewAsk";
import AplyNow from "../screens2/Requirement/ApplayNow";
import CandidateView from "../screens/InternalTracker/Requirements/CandidateView";
import CandidateListingDetails from "../screens2/Candidates/CandidateListing/CandidateListingDetails";
import AddCandidateExperiencess from "../screens/Candidates/AddCandidate/AddCandidateExperience";
import RequirementTrackerViewDetails from "../screens/InternalTracker/Requirements/RequirementsTrackerViewDetails";
import Privacy from "../screens/HomeNew/Privacy";
import Refund from "../screens/HomeNew/Refund";
import Website from "../screens/HomeNew/Website";
import DataBackUp from "../screens/HomeNew/DataBackUp";
import SafeJob from "../screens/HomeNew/SafeJob";
import Reporting from "../screens/HomeNew/Reporting";
import ApplyCandidate from "../screens2/Requirement/ApplyCandidate";
import SearchJobResults from "../screens/PostSearch/SearchJobResults";
import Credit from "../screens2/Credit";
import PageNotFound from "../screens/404/PageNotFound";
import Dashboard from "../screens/Dashboard/index";
import BugReportForm from "../screens2/Bugs/index";

import AddConsultantResumeDeomo from "../screens/CandidateDemo/AddCandidate/AddConsultantResume";
import AddConsultantSubmitDemo from "../screens/CandidateDemo/AddCandidate/AddConsultantSubmit";
import AddConsultantDemo from "../screens/CandidateDemo/AddCandidate/AddConsultant";
import AddCandidateExperiencessDemo from "../screens/CandidateDemo/AddCandidate/AddCandidateExperience";
import CandidateDemo from "../screens/CandidateDemo/AddCandidate";
import CandiDateNew from "../screens/InternalTracker/Candidate/CandidateNew";
import SearchSelectJob from "../screens/PostSearch/SearchSelectJob";
import HotList from "../screens2/HotList";
import HotlistItRec from "../screens/HotList";

const authProtected = [{ path: "*", component: <Navigate to="/" /> }];

const authProtectedRoutes = [
  {
    path: "/post-requirement-view",
    component: <PostRquirementView />,
    roles: ["it_recruiter"],
  },
  {
    path: "/profile-view",
    component: <ProfileView />,
    roles: ["it_recruiter"],
  },
  { path: "/profile", component: <Profile />, roles: ["it_recruiter"] },

  {
    path: "/add-candidate-personal",
    component: <AddPersonal />,
    roles: ["it_recruiter"],
  },
  {
    path: "/add-candidate-public",
    component: <AddCandidatePublic />,
    roles: ["it_recruiter"],
  },
  {
    path: "/add-candidate-resume",
    component: <AddCandidateResume />,
    roles: ["it_recruiter"],
  },
  {
    path: "/candidate-listing",
    component: <CandidateListing />,
    roles: ["it_recruiter"],
  },
  {
    path: "/candidate-add-experience",
    component: <AddCandidateExperiencess />,
    roles: ["it_recruiter"],
  },
  {
    path: "/search-candidate-candidate-details",
    component: <ViewCandidateDetails />,
    roles: ["it_recruiter"],
  },
  {
    path: "/search-candidate-view-public-resume",
    component: <ViewPublicResume />,
    roles: ["it_recruiter"],
  },
  {
    path: "/post-request-submit",
    component: <PostRequestSubmit />,
    roles: ["it_recruiter"],
  },
  {
    path: "/post-search-result",
    component: <PostSearchResult />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-candidate-resume-details",
    component: <ViewInternalResumeDetails />,
    roles: ["it_recruiter"],
  },

  {
    path: "/mass-mailing",
    component: <MassMailing />,
    roles: ["it_recruiter"],
  },
  {
    path: "/mass-mailing-portal",
    component: <MassMailingPortal />,
    roles: ["it_recruiter"],
  },

  {
    path: "/mass-mailing-portal-new",
    component: <MassMailingPortalNew />,
    roles: ["it_recruiter"],
  },
  {
    path: "/mass-mailing-sales-recruiter",
    component: <MassMailingSalesRecruiter />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker",
    component: <InternalTracker />,
    roles: ["it_recruiter"],
  },

  {
    path: "/submision-tracker",
    component: <RequirementsTracker />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker-view",
    component: <InternalTrackerView />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-view",
    component: <InternalView />,
    roles: ["it_recruiter"],
  },
  // {
  //   path: "/internal-tracker-Add",
  //   component: <InternalTrackerAdd />,
  //   roles: ["it_recruiter"],
  // },
  {
    path: "/internal-tracker-Add",
    component: <CandiDateNew />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker-review",
    component: <InternalTrackerAddReview />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-Add",
    component: <InternalAdd />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker-candidate",
    component: <InternalTrackerCandidate />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-requirements",
    component: <InternalRequirement />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker-submit",
    component: <InternalTrackerSubmit />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-submit",
    component: <InternalSubmit />,
    roles: ["it_recruiter"],
  },
  {
    path: "/post-search-list",
    component: <PostSearch />,
    roles: ["it_recruiter"],
  },
  {
    path: "/job-post-list-view",
    component: <JobPostListView />,
    roles: ["it_recruiter"],
  },
  {
    path: "/post-job-requirement",
    component: <PostJobRequirement />,
    roles: ["it_recruiter"],
  },
  {
    path: "/search-candidate",
    component: <SearchJobResults />,
    roles: ["it_recruiter"],
  },
  {
    path: "/search-candidate-job",
    component: <SearchSelectJob />,
    roles: ["it_recruiter"],
  },
  {
    path: "/candidate-view-resume",
    component: <CandidateViewResume />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker-submissions",
    component: <InternalTrackerSubmissions />,
    roles: ["it_recruiter"],
  },
  {
    path: "/hot-list",
    component: <HotList />,
    roles: ["it_recruiter"],
  },

  {
    path: "/hot-list-recruiters",
    component: <HotlistItRec />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker-employee",
    component: <InternalTrackerEmployee />,
    roles: ["it_recruiter"],
  },

  {
    path: "/dashboard",
    component: <Dashboard />,
    roles: ["it_recruiter"],
  },

  {
    path: "/dashboard-credit",
    component: <DashboardCredit />,
    roles: ["it_recruiter"],
  },
  {
    path: "/dashboard-transfer",
    component: <DashboardTransfer />,
    roles: ["it_recruiter"],
  },
  {
    path: "/profile-save",
    component: <ProfileSave />,
    roles: ["it_recruiter"],
  },
  { path: "/bench-view", component: <BenchView />, roles: ["it_recruiter"] },
  {
    path: "/submision-tracker-candidate-details",
    component: <CandidateView />,
    roles: ["it_recruiter"],
  },
  { path: "/more-view", component: <MoreView />, roles: ["it_recruiter"] },
  // {
  //   path: "/search-candidate-result",
  //   component: <SearchJobResults />,
  //   roles: ["it_recruiter"],
  // },
  {
    path: "/more-view-details",
    component: <MoreViewDetails />,
    roles: ["it_recruiter"],
  },
  {
    path: "/more-view-internal-details",
    component: <MoreViewInternalDetails />,
    roles: ["it_recruiter"],
  },
  { path: "/send-job", component: <SendJob />, roles: ["it_recruiter"] },
  {
    path: "/send-job-internal",
    component: <SendJobInternal />,
    roles: ["it_recruiter"],
  },
  { path: "/helpdesk", component: <HelpDesk />, roles: ["it_recruiter"] },
  { path: "/invite", component: <Invite />, roles: ["it_recruiter"] },
  { path: "/jobpost", component: <Requirement />, roles: ["it_recruiter"] },
  {
    path: "/requirement-view",
    component: <RequirementView />,
    roles: ["it_recruiter"],
  },
  {
    path: "/jobpost-apply-view",
    component: <RequirementApplyView />,
    roles: ["it_recruiter"],
  },
  {
    path: "/requirement-ask-view",
    component: <RequirementAskView />,
    roles: ["it_recruiter"],
  },
  {
    path: "/jobpost-list-view",
    component: <ApplyNow />,
    roles: ["it_recruiter"],
  },
  { path: "/active-jobs", component: <ActiveJobs />, roles: ["it_recruiter"] },
  {
    path: "/jobpost/add",
    component: <RequirementPost />,
    roles: ["it_recruiter"],
  },
  {
    path: "/internal-tracker-experience",
    component: <InternalTrackerExperience />,
    roles: ["it_recruiter"],
  },

  {
    path: "/add-candidate-personal",
    component: <AddPersonal />,
    roles: ["it_recruiter"],
  },
  {
    path: "/add-candidate-public",
    component: <AddCandidatePublic />,
    roles: ["it_recruiter"],
  },
  {
    path: "/add-candidate-resume",
    component: <AddCandidateResume />,
    roles: ["it_recruiter"],
  },
  {
    path: "/candidate-listing",
    component: <CandidateListing />,
    roles: ["it_recruiter"],
  },
  {
    path: "/candidate-listing-details",
    component: <CandidateListingDetails />,
    roles: ["it_recruiter"],
  },
  {
    path: "/requirement",
    component: <Requirementss />,
    roles: ["it_recruiter"],
  },
  { path: "/more-views", component: <MoreViews />, roles: ["it_recruiter"] },
  {
    path: "/more-view-apply",
    component: <MoreViewApply />,
    roles: ["it_recruiter"],
  },
  {
    path: "/more-view-ask",
    component: <MoreViewAsk />,
    roles: ["it_recruiter"],
  },
  {
    path: "/requirement-details-view",
    component: <AplyNow />,
    roles: ["it_recruiter"],
  },
  {
    path: "/requirement-candidate-apply",
    component: <ApplyCandidate />,
    roles: ["it_recruiter"],
  },
  {
    path: "/credit",
    component: <Credit />,
    roles: ["it_recruiter"],
  },

  {
    path: "/requirement-tracker-view-details",
    component: <RequirementTrackerViewDetails />,
    roles: ["it_recruiter"],
  },

  {
    path: "/add-consultant-resume",
    component: <AddConsultantResumeDeomo />,
    roles: ["it_recruiter"],
  },
  {
    path: "/add-consultant-submit",
    component: <AddConsultantSubmitDemo />,
    roles: ["it_recruiter"],
  },
  {
    path: "/add-consultant",
    component: <CandidateDemo />,
    roles: ["it_recruiter"],
  },

  {
    path: "/candidate-add-experience-demo",
    component: <AddCandidateExperiencessDemo />,
    roles: ["it_recruiter"],
  },

  {
    path: "/bugs",
    component: <BugReportForm />,
    roles: ["it_recruiter"],
  },
];

const publicRoutes = [
  { path: "/contact-us", component: <ContactUsNew /> },
  { path: "/about-us", component: <AboutUsNew /> },
  {
    path: "/our-platform",
    component: <OurPlatformNew />,
  },
  { path: "/security", component: <SecurityNew /> },
  {
    path: "/feedback-more",
    component: <FeedbackMore />,
  },
  {
    path: "/feedback-next",
    component: <FeedbackNext />,
  },
  { path: "/privacy-policy", component: <Privacy /> },
  { path: "/refund-policy", component: <Refund /> },
  { path: "/term-of-use", component: <Website /> },
  {
    path: "/data-backup-policy",
    component: <DataBackUp />,
  },
  { path: "/safe-job-search", component: <SafeJob /> },
  {
    path: "/reporting-fraud",
    component: <Reporting />,
  },
  {
    path: "/",
    component: <HomeNew />,
  },
  { path: "/login", component: <LoginNew /> },
  { path: "/it-recruiter-signup", component: <SignupNew /> },
  { path: "/benchsales-signup", component: <BenchSalesSignup /> },
  { path: "/page-not-found", component: <PageNotFound /> },
  { path: "*", component: <Navigate to="/page-not-found" /> },
];

export { authProtected, publicRoutes, authProtectedRoutes };
